const REQUIRED_CARDS = [
  'vendors',
  'vendor_rooms',
  'daily',
  'details',
  'destinations',
  'ending_soon',
  'recently_ended',
  'snapshots',
  'choices',
  'daily_blackout',
  'calendar_bnbl',
];

/** One request must finish every required card before its rows/metadata are authoritative. */
export function inventoryReady({
  from,
  to,
  success,
  fetching,
  previous,
  error,
  cards,
  problems,
}: {
  from: string;
  to: string;
  success: boolean;
  fetching: boolean;
  previous: boolean;
  error: unknown;
  cards: Array<{ cardId: string; status: string; truncated?: boolean }>;
  problems: Array<unknown>;
}) {
  const validDate = (value: string) =>
    !value ||
    (/^\d{4}-\d{2}-\d{2}$/.test(value) &&
      !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) &&
      new Date(`${value}T00:00:00Z`).toISOString().slice(0, 10) === value);
  return (
    validDate(from) &&
    validDate(to) &&
    !(from && to && from > to) &&
    success &&
    !fetching &&
    !previous &&
    !error &&
    cards.length === REQUIRED_CARDS.length &&
    REQUIRED_CARDS.every((id) => cards.some((card) => card.cardId === id)) &&
    cards.every((card) => ['ready', 'empty'].includes(card.status) && !card.truncated) &&
    !problems.length
  );
}
